import { t } from '@lingui/core/macro';
import { createSnackbar } from '@luminovo/design-system';
import { useSnackbar } from 'notistack';
import React, { type JSX } from 'react';

import { subscribeToStaleApp } from '@/shared/utils/staleApp';

/** Offers the reload a stale tab needs (see `shared/utils/staleApp.ts`); no auto-hide: lazy chunks fail until then. */
export function StaleAppReloadPrompt(): JSX.Element | null {
    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
        return subscribeToStaleApp(() => {
            const [message, options] = createSnackbar({
                title: t`A new version is available`,
                message: t`Reload to continue. Parts of the page will not load until you do.`,
                actionButtonOptions: {
                    buttonText: t`Reload`,
                    onClick: () => window.location.reload(),
                },
                overrides: {
                    notistackSnackbarOptions: {
                        variant: 'warning',
                        persist: true,
                        key: 'stale-app-reload-prompt',
                    },
                },
            });

            enqueueSnackbar(message, options);
        });
    }, [enqueueSnackbar]);

    return null;
}
